import { BaseApiService } from "@services/baseApiService";
import { api } from "@services/api";
import {
  TemplateOutputDTO,
  TemplateDocumentResponse,
  MappingRule,
  TemplatePieceConfig,
} from "./types";
import { ApiResponse, ApiError } from "@/types/api";

class TemplateService extends BaseApiService<TemplateOutputDTO> {
  constructor() {
    super("templates");
  }

  async create(
    data: Partial<TemplateOutputDTO>
  ): Promise<ApiResponse<TemplateOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const templateData = {
      ...data,
    };

    return await super.create(templateData);
  }

  async update(
    id: string,
    data: Partial<TemplateOutputDTO>
  ): Promise<ApiResponse<TemplateOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const templateData = {
      ...data,
    };

    return await super.update(id, templateData);
  }

  async generateDocument(
    id: string,
    payload: {
      mappingRules?: MappingRule[];
      clientId?: string;
      filledFormId?: string;
      replacements?: Record<string, string>;
    }
  ): Promise<ApiResponse<TemplateDocumentResponse> | ApiError> {
    return await api.request<TemplateDocumentResponse>(
      `${this.baseUrl}/${id}/document`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );
  }

  async getConfig(
    id: string
  ): Promise<ApiResponse<{ config: TemplatePieceConfig }> | ApiError> {
    return await api.request<{ config: TemplatePieceConfig }>(
      `${this.baseUrl}/${id}/config`,
      {
        method: "GET",
      }
    );
  }

  async saveConfig(
    id: string,
    payload: {
      mappings: MappingRule[];
      baseForm?: string;
    }
  ): Promise<ApiResponse<{ config: TemplatePieceConfig }> | ApiError> {
    return await api.request<{ config: TemplatePieceConfig }>(
      `${this.baseUrl}/${id}/config`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );
  }
}

export const templateService = new TemplateService();
